<template>
	<div class="page-footer">
		<div class="page-footer-body">
			<div class="left-box">
				<div class="title">OPULRICH</div>
				<div class="sub-title">
					我们相信，每一个渴望成长与超越的人，都能在OPULRICH的陪伴下，穿越迷茫与困顿，持续汲取智慧与能量，唤醒内在的生命力，最终实现身心和谐、内外兼修的圆满人生。
				</div>
			</div>
			<div class="center-box">
				<div class="contact">
					Contact Us
				</div>
				<div class="localtion">
					<img class="icon icon-localtion"
						src="@/assets/location.png" />
					<span>OPULRICH PTE. LTD.3 FRASER STREET
						#04-23A DUO TOWER SINGAPORE (189352)</span>
				</div>
				<div class="phone">
					<img class="icon icon-phone"
						src="@/assets/phone.png" />
					<span>+65 88079862</span>
				</div>
			</div>
			<div class="right-box">
				<div class="email">
					<img class="icon icon-email"
						src="@/assets/email.png" />
					<span>amy@opulrich.com.sg</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
</script>

<style lang="scss"
	scoped>
	.page-footer {
		margin-top: 50px;
		width: 100%;
		height: 300px;
		background-color: #001B2F;
		padding-top: 50px;
		display: flex;
		justify-content: center;
	}

	.page-footer-body {
		margin: 0 auto;
		color: #ffffff;
		display: flex;
		box-sizing: border-box;
		width: 80%;

		.left-box {
			width: 33%;
			padding-right: 100px;
			box-sizing: border-box;


			.title {
				font-size: 20px;
			}

			.sub-title {
				margin-top: 10px;
				font-size: 13px;
				line-height: 20px;
			}
		}

		.center-box {
			width: 33%;
			padding-right: 100px;
			box-sizing: border-box;

			.contact {
				font-size: 16px;
				font-weight: bold;
			}


			.localtion {
				margin-top: 20px;
				display: flex;
				align-items: center;

				.icon {
					margin-right: 20px;
					width: 16px;
					height: 16px;
				}
			}

			.phone {
				margin-top: 20px;
				display: flex;
				align-items: center;

				.icon {
					margin-right: 20px;
					width: 16px;
					height: 16px;
				}
			}
		}

		.right-box {
			flex-shrink: 0;
			padding-right: 100px;
			box-sizing: border-box;
			padding-top: 30px;

			.email {
				display: flex;
				align-items: center;

				.icon {
					margin-right: 20px;
					width: 16px;
					height: 16px;
				}
			}
		}
	}
</style>